import {Observable} from 'rxjs';

import {GetUsuryRatePayloadDto} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.payload.dto';
import {GetUsuryRateResponseDto} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.response.dto';

export abstract class GetUsuryRateUseCasePort {
  abstract execute(payload: GetUsuryRatePayloadDto): Observable<GetUsuryRateResponseDto>;
}
